import { Component, EventEmitter, Input, Output, SimpleChange, SimpleChanges, ViewChild } from "@angular/core";
import { SalesReceiptPdfComponent } from "src/app/sales-receipt-pdf/sales-receipt-pdf.component";
import { IDynamicObject } from "../models/sales-receipt.model";
import { CustomAttributeFieldType, SOChannel } from "../constants/constants";
import { AppMainComponent } from "src/app/app.main.component";
import { ListService } from "src/app/configurations/inventory/custom/list/list.service";
import { DatePipe } from "@angular/common";
import { SalesOrderService } from "../sales-order.service";
import { AccountsTransactionType, TransactionNames } from "src/app/finance/constants/constants";
import { ModuleName } from "src/app/modules/shared/components/receive-payments/constants/constants";
import { ICustomAtributes } from "src/app/modules/shared/components/receive-payments/model/receive-payment.model";

@Component({
    selector: "app-sales-receipt-details",
    templateUrl: "./sales-receipt-details.component.html",
})
export class SalesReceiptDetailsComponent {
    @Input() display;
    @Input() fractionDigits;
    @Input() salesReceiptsTemplate;
    @Input() salesReceiptsByIdList;
    @Input() estimatesCols2;
    @Input() selectedRowData;
    @Input() soChannel;
    @Input() companyInfo;
    @Input() receivedPaymentId;
    @Input() channelName;
    @Input() trackingOptions;
    @Output() cancel = new EventEmitter();
    @Output() editSalereceipt = new EventEmitter();
    @ViewChild(SalesReceiptPdfComponent) srPdf: SalesReceiptPdfComponent;
    receivePaymentDetails;
    invoicingDetails;
    memo : string = '';
    InvoiceTB;
    fieldTypes = CustomAttributeFieldType;
    moduleName = ModuleName;
    accountinfo: any;
    amountTotal;
    amountDueTotal;
    amountAppliedTotal;
    writeOffAmountTotal;
    customAtributes: ICustomAtributes = {
        other1_item: [],
        other2_item: [],
        other3_item: [],
        labels_misc: [],
        labels_message: [],
    };
    allModules: any[] = [];
    allCustomFields: any[] = [];
    customFieldData: any[] = [];
    displayInventoryOverview: boolean = false;
    inventoryOverviewRefId: number = 0;
    inventoryOverviewRefNumber: string = "";
    inventoryOverviewModule: string = "";
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number = 0;
    selectedAccountChannelId: number = 0;
    constructor(
        public app: AppMainComponent,
        private customfieldService: ListService,
        public datepipe: DatePipe,
        private salesOrderService: SalesOrderService,
    ) {}
    ngOnChanges(changes: SimpleChange) {
        if (changes["salesReceiptsByIdList"].currentValue || changes["estimatesCols2"].currentValue) {
            this.accountinfo = this.generateDynamicObject(this.estimatesCols2, this.salesReceiptsByIdList);
            this.loadCustomFields();
            this.detailsView();
        }
    }

    ngOnInit() {}

    onCancel() {
        this.cancel.emit();
    }
    salesReceiptPrint() {
        setTimeout(() => {
            this.srPdf.generatePrint();
        }, 1000);
    }
    viewTxnData(bill) {}
    editSalesReceipt() {
        this.editSalereceipt.emit();
    }
    detailsView() {
        this.salesOrderService.getReceivedPaymentsById(this.receivedPaymentId).subscribe((resp) => {
            this.invoicingDetails = resp;
            this.InvoiceTB = this.invoicingDetails?.receivedPaymentDetail?.map((r) => {
                const obj = {
                    ...r,
                    invoiceId: r?.transactionType == AccountsTransactionType.JournalEntry ? r.txnId : r.invoiceId,
                    invoiceNo: r?.transactionType == AccountsTransactionType.JournalEntry ? r.txnNumber : this.channelName === this.soChannel.SALES_ORDER ? r.salesOrderNumber : r.invoiceNumber,
                    invoiceAmount: r.invoiceAmount ?? 0,
                    exchangeRate: r.invoice?.exchangeRate,
                    currencyCode: r.invoice?.currencyCode,
                    // amountDue: r.amountDue ?? 0,
                    // actualDueAmount: r.amountDue ?? 0,
                    due: r.amountDue ?? 0,
                    credit: r.appliedCredit ?? 0,
                    amountApplied: r.invoiceReceivedAmount ?? 0,
                    contactId: "",
                    isCreditApplied: r.appliedCredit && r.appliedCredit > 0,
                    isReceivedPaymentApplied: true,
                    dueDate: r.dueDate ? this.app._showDateTimeWithZone(r.dueDate) : "",
                    netDueAmount: r.amountDue ?? 0,
                    actualDueAmount: r?.invoiceReceivedAmount + r?.amountDue + r?.appliedCredit,
                    // amountDue: r?.invoiceReceivedAmount + r?.amountDue + r?.appliedCredit - r?.invoiceReceivedAmount,
                };
                // this.amountTotal += Number(obj.invoiceAmount);
                // this.amountDueTotal += Number(obj.amountDue);
                // this.amountAppliedTotal += Number(obj.amountApplied);
                // this.writeOffAmountTotal += Number(obj.writeOffAmount);
                return obj;
            });
            this.memo = this.invoicingDetails?.receivedPaymentNote && this.invoicingDetails?.receivedPaymentNote.length > 0
                ? this.invoicingDetails?.receivedPaymentNote[this.invoicingDetails?.receivedPaymentNote.length - 1].note.comment
                : ""
        });
    }
    generateDynamicObject(columns, salesReceiptsByIdList: any[]): IDynamicObject[] {
        if (salesReceiptsByIdList.length === 0) {
            return [];
        }
        const firstItem = salesReceiptsByIdList[0];
        return columns
            .filter((col) => col.show)
            .map((col) => ({
                header: col.header,
                datatype: col.datatype,
                value: firstItem[col.field],
            }));
    }
    async loadCustomFields() {
        this.allModules = this.app.preLoadedObjects;
        const obj = this.allModules.filter((obj) => obj.name == "Orders")[0];
        this.customfieldService.getAllCustomFields(obj.id).then((response) => {
            this.customFieldData = [];
            this.allCustomFields = [];
            const fields = response?.filter((el) => el.section?.typeName == "Sales Receipt");

            if (fields && fields.length > 0) {
                for (let l of fields) {
                    let eachRecord = {
                        id: Number(l.id + ""),
                        name: l.name,
                        module: this.allModules.find((el) => el.id == l.objectId)?.name,
                        formControl: l.formControl,
                        formControlId: l.formControlId,
                        isRequired: l.isRequired,
                        statusId: l.statusId,
                        statusName: l.status.name,
                        section: l.section,
                        configurationId: l.configurationId,
                        isEdit: l.isEdit,
                        isDelete: l.isDelete,
                        pickupList: l.pickListValues ? JSON.stringify(l.pickListValues) : l.pickListValues,
                    };
                    this.customFieldData.push(eachRecord);
                }
            }
            this.allCustomFields = this.customFieldData;
            this.customAtributes.labels_misc = this.allCustomFields.filter((el) => el.section?.code == "labels_misc");
            this.customAtributes.labels_message = this.allCustomFields.filter((el) => el.section?.code == "labels_message");
            this.customAtributes.other1_item = this.allCustomFields.filter((el) => el.section?.code == "labels_salesreceipt_other1");
            this.customAtributes.other2_item = this.allCustomFields.filter((el) => el.section?.code == "labels_salesreceipt_other2");
            this.customAtributes.other3_item = this.allCustomFields.filter((el) => el.section?.code == "labels_salesreceipt_other3");
            this.setCustomFieldsData();
        });
    }

    setCustomFieldsData() {
        Object.keys(this.customAtributes).forEach((key) => {
            const dataArr = this.customAtributes[key];
            if (Array.isArray(dataArr) && dataArr.length > 0) {
                dataArr.forEach((element) => {
                    const sectionCode = element.section?.code;
                    const templateSection = this.salesReceiptsTemplate?.[sectionCode];
                    const matchedItem = templateSection?.find((el: any) => el.id === element?.id);
                    const isChecked = matchedItem?.isChecked ?? false;

                    element.isChecked = isChecked;

                    const filteredCustom = this.salesReceiptsByIdList[0]?.CustomAttributes?.find((c: any) => c.customAttributeId === element.id);

                    const controlType = filteredCustom?.customAttribute?.formControl?.name;

                    switch (controlType) {
                        case "InputBox":
                            element.value = filteredCustom.value;
                            break;

                        case "Decimal":
                            element.value = filteredCustom.value;
                            break;

                        case "DatePicker":
                            element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
                            break;

                        case "FileUpload":
                        case "Picture":
                            element.customUploadedFiles = [...(filteredCustom?.customeAttachement ?? [])];
                            break;

                        case "Rating":
                            element.value = filteredCustom.ratingId;
                            break;

                        case "ToggleButton":
                            element.value = filteredCustom.toggle;
                            break;

                        case "DropDownList":
                            element.value = filteredCustom.values;
                            break;

                        case "RadioButton":
                            element.value = filteredCustom.values?.name;
                            break;

                        case "CheckBox":
                        case "MultipleDropDownList":
                            element.value = filteredCustom.multipleValues?.map((el: any) => (controlType === "CheckBox" ? el.name : el)) ?? [];
                            break;

                        default:
                            element.value = null;
                            break;
                    }
                });
            }
        });

        // Remove unchecked elements
        Object.keys(this.customAtributes).forEach((key) => {
            if (Array.isArray(this.customAtributes[key])) {
                this.customAtributes[key] = this.customAtributes[key].filter((item) => item.isChecked);
            }
        });
    }
    showInventoryDialog(rowData) {
        this.inventoryOverviewRefId = rowData?.id || 0;
        this.inventoryOverviewRefNumber = rowData?.number;
        this.inventoryOverviewModule = TransactionNames.Invoice;
        this.displayInventoryOverview = true
      }

      closeViewPopup() {
        this.displayInventoryOverview = false;
      }
      onAccountNameClick() {
        this.selectedAccountId = this.invoicingDetails?.accountId;
        this.selectedAccountChannelId = this.invoicingDetails?.channelId;
        this.displayAccountViewEdit = true;
      } 
      closeAccountViewEditModal() {
        this.displayAccountViewEdit = false;
        this.selectedAccountId = 0;
        this.selectedAccountChannelId = 0;
      }
}
